module.exports = __webpack_public_path__ + "img/blue-shadow.3dc04c90.png";